<template>
  <v-dialog
    v-model="getModalEstornoNfe"
    fullscreen
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Gerar NF-e de Estorno</v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="formNfeEstorno">
          <v-layout row wrap>
            <v-flex xs12 md2>
              <v-text-field
                label="CFOP"
                class="mr-1 ml-1"
                v-model="nfe.cfop"
                id="id"
                outlined
                dense
                v-mask="'#.###'"
                :rules="rules.cfop"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="getTiposFreteNfe"
                v-model="nfe.tipo_frete"
                label="Frete por Conta:"
                item-text="descricao"
                item-value="id"
                outlined
                dense
                class="ml-1 mr-1"
                :rules="rules.tipo_frete"
              ></v-select>
            </v-flex>

            <v-flex xs12 md4 v-if="nfe.tipo_frete != 9">
              <v-autocomplete
                :items="getTransportadoras"
                item-text="nome"
                item-value="id"
                label="Transportadora:"
                v-model="nfe.transportadora_id"
                class="mr-1 ml-1"
                outlined
                dense
                append-outer-icon="control_point"
                @click:append-outer="cadastrarContato"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="getTiposOperacaoNfe"
                v-model="nfe.tipo_operacao"
                label="Operação:"
                item-text="descricao"
                item-value="id"
                outlined
                dense
                class="ml-1 mr-1"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td colspan="5">
                        <h3 class="red--text">Produtos:</h3>
                      </td>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th></th>
                      <th class="text-left">Cód.</th>
                      <th class="text-left">Produto</th>
                      <th class="text-left">Pre. Venda</th>
                      <th class="text-left">Quant.</th>
                      <th></th>
                      <th></th>
                      <th class="text-left">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itensVenda" :key="item.id">
                      <td>
                        <v-checkbox v-model="item.devolver"></v-checkbox>
                      </td>
                      <td>{{ item.produto_id }}</td>
                      <td>{{ item.descricao }}</td>
                      <td>
                        {{ $helper.formatReal(parseFloat(item.preco_venda)) }}
                      </td>
                      <td>
                        {{ $helper.formatReal(parseFloat(item.quantidade)) }}
                      </td>
                      <td>
                        <v-text-field
                          v-if="item.devolver"
                          outlined
                          dense
                          class="mt-5"
                          v-mask="[
                            '#,##',
                            '##,##',
                            '###,###',
                            '#.###,##',
                            '##.###,##',
                            '###.###,##',
                          ]"
                          v-model="item.quantidade_devolvida"
                          @input="verificaQuantidadeDevolvida(item)"
                          label="QTD. a Devolver"
                          :rules="rules.quantidade"
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-if="item.devolver"
                          label="CFOP"
                          outlined
                          class="mt-5"
                          dense
                          v-model="item.cfop"
                          :rules="rules.cfop_item"
                          v-mask="'#.###'"
                        ></v-text-field>
                      </td>
                      <td>{{ item.total_venda }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                dense
                outlined
                class="mr-1 ml-1"
                label="Justificativa:"
                v-model="nfe.justificativa"
                :rules="rules.justificativa"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-textarea
                dense
                outlined
                class="mr-1 ml-1"
                label="Informações Complementares:"
                v-model="nfe.informacao_complementar"
                :rules="rules.informacao_complementar"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Chave NF-e Ref."
                outlined
                dense
                class="mr-1 ml-1"
                v-model="nfe.chave_nfe_referencia"
                :rules="rules.chave_nfe_referencia"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="default"
          outlined
          @click="setModalEstornoNfe(false)"
          :loading="$store.getters.getOverlay"
          >Fechar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          outlined
          @click="_estornarNfe()"
          :loading="$store.getters.getOverlay"
          >Gerar NF-e</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import ContatoService from "@/services/ContatoService"

export default {
  data() {
    return {
      nfe: {
        cfop: "1.949",
        informacao_complementar: "",
        transportadora_id: "",
        tipo_frete: 9,
        chave_nfe_referencia: "",
        justificativa: "",
        itens: [],
        tipo_operacao: 1,
      },
      itensVenda: [],
      rules: {
        cfop: [(v) => !!v || "Campo obrigatório."],
        chave_nfe_referencia: [(v) => !!v || "Campo obrigatório."],
        justificativa: [(v) => !!v || "Campo obrigatório."],
        informacao_complementar: [(v) => !!v || "Campo obrigatório."],
        cfop_item: [(v) => !!v || "Campo obrigatório."],
        quantidade: [(v) => !!v || "Campo obrigatório."],
        tipo_frete: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  watch: {
    getModalEstornoNfe() {
      if (this.getModalEstornoNfe == true) {
        this.listarTransportadoras();
        // this.listarClientes();
        setTimeout(() => {
          this.itensVenda = [];
          this.itensVenda = [...this.getVenda.itens];
          console.log("itens venda", this.itensVenda);
          this.nfe.informacao_complementar = `Estorno de NF-e não cancelada no prazo legal refrente a NF-e ${this.getVenda.chave_nfe}.`;
          this.nfe.chave_nfe_referencia = this.getVenda.chave_nfe;
        }, 50);
      }
    },
  },

  computed: {
    ...mapGetters([
      "getModalEstornoNfe",
      "getVenda",
      "getTiposFreteNfe",
      "getTransportadoras",
      "getTiposOperacaoNfe",
    ]),
  },
  methods: {
    ...mapActions([
      "setModalEstornoNfe",
      "listarTransportadoras",
      "cadastrarContato",
      "estonarNfe",
    ]),
    verificaQuantidadeDevolvida(item) {
      const verifica = _.debounce(() => {
        if (
          this.$helper.cleanFormatReal(item.quantidade_devolvida) >
          parseFloat(item.quantidade)
        ) {
          this.$store.commit("alertError", [
            "A quantidade devolvida não pode ser maior que a quantidade registrada.",
          ]);

          item.quantidade_devolvida = "";
          item.devolver = false;
          // const indexItemVenda = this.itensVenda.indexOf(item);
          // this.itensVenda[indexItemVenda].quantidade_devolvida = "";
          // this.itensVenda[indexItemVenda].devolver = false;
        }
      }, 300);

      verifica();
    },
    _estornarNfe() {
      if (this.$refs.formNfeEstorno.validate() == false) {
        return;
      }

      this.nfe.itens = [];
      this.itensVenda.map((i) => {
        if (i.devolver) {
          this.nfe.itens.push({
            produto_id: i.produto_id,
            cfop: i.cfop,
            quantidade: this.$helper.cleanFormatReal(i.quantidade_devolvida),
            descricao: i.descricao,
            preco_venda:
              this.$helper.cleanFormatReal(i.quantidade_devolvida) *
              i.preco_venda,
          });
        }
      });

      if (this.nfe.itens.length <= 0) {
        this.$store.commit("alertError", ["Informa um produto."]);

        return;
      }
      this.nfe.venda_id = this.getVenda.id;
      this.estonarNfe(this.nfe);
    },
    // listarClientes() {
    //   ContatoService.listar({
    //     query: {
    //       campo: "todos",
    //     },
    //   })
    //     .then((res) => {
    //       this.$store.commit("setContatos", res.data);
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },
  },
};
</script>